import http from '@/core/http'

const state = {
  itens: [],
  totalItens: 0,
}

const actions = {
  getItens: async ({ commit }, payload) => {
    const result = await http.get('requisicoes-premio-web', { params: payload })
    commit('GET_ITENS', result.data)
    return Promise.resolve(result.data)
  },
}

const mutations = {
  'GET_ITENS' (state, payload) {
    state.itens = payload.result
    state.totalItens = payload.totalItens
  },
}

const getters = {
  listaItens: state => state.itens,
  totalItens: state => state.totalItens,
}

export default { namespaced: true, state, actions, mutations, getters }